// extracted by mini-css-extract-plugin
export var chevronIcon = "_al-2";
export var teamName = "_al-1";
export var teamSwitcherButton = "_al-0";